import { ConstraintConf } from '../constraints/constraint-conf'
import { ProcessingTimeConf } from '../capacities/processing-time-conf'
import { SkillSetSpec } from '../../../../process/capability-spec/skillsets/skill-set-spec'

export class SkillSetConf {
  public id: string
  public skillSetSpecId: string
  public conditions: ConstraintConf[] = []
  public constraints: ConstraintConf[] = []
  public capacities: ProcessingTimeConf[][] = []
  public description: string

  public spec: SkillSetSpec
}
